(function () {
  // ========= SETTINGS (adjust selectors if your theme differs) =========
  // Drawer wrapper – used only to keep it open
  const DRAWER_ROOT_SELECTOR =
    '[data-cart-drawer], #CartDrawer, cart-drawer, [data-drawer="cart"]';

  // A minimal “keep open” that works with theme
  function forceDrawerOpen() {
    const drawer = document.querySelector(DRAWER_ROOT_SELECTOR);
    if (!drawer) return;
    drawer.classList.add('is-open', 'open', 'active');
    try { drawer.setAttribute('aria-hidden', 'false'); } catch {}
    if (drawer.tagName && drawer.tagName.toLowerCase() === 'cart-drawer') {
      try { drawer.setAttribute('open', ''); drawer.open = true; } catch {}
    }
    document.dispatchEvent(new CustomEvent('cart:open'));
  }

  // ========= HELPERS =========
  const $$ = (sel, ctx = document) => Array.from((ctx || document).querySelectorAll(sel));

  function parseHandleAndVariantFromLink(aEl) {
    if (!aEl) return {};
    try {
      const u = new URL(aEl.getAttribute('href'), window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const pIdx = parts.indexOf('products');
      const handle = pIdx > -1 ? parts[pIdx + 1] : '';
      const variantId = u.searchParams.get('variant') || '';
      return { handle, variantId };
    } catch { return {}; }
  }

  async function getJSON(url) {
    const r = await fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With':'XMLHttpRequest' } });
    if (!r.ok) throw new Error(r.status);
    return r.json();
  }

  async function postJSON(url, body) {
    const r = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type':'application/json', Accept:'application/json', 'X-Requested-With':'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    if (!r.ok) throw new Error(await r.text().catch(()=>String(r.status)));
    return r.json();
  }

  function firstPlan(productJson) {
    const g = productJson?.selling_plan_groups?.[0];
    const p = g?.selling_plans?.[0];
    return p ? { id: p.id, name: p.name || '' } : null;
  }

  function makeCTA(plan) {
    const wrap = document.createElement('div');
    wrap.className = 'rc-upsell-wrap';
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rc-upsell-link';
    btn.textContent = 'Subscribe & save';
    btn.dataset.sellingPlanId = String(plan.id);
    wrap.appendChild(btn);
    if (plan.name) {
      const hint = document.createElement('small');
      hint.className = 'rc-upsell-hint';
      hint.textContent = plan.name;
      wrap.appendChild(hint);
    }
    return wrap;
  }

  function showSwitchedBadge(target, planName) {
    const note = document.createElement('small');
    note.className = 'rc-upsell-switched';
    note.style.display = 'block';
    note.style.opacity = '0.8';
    note.textContent = planName ? ` Subscription | Delivers ${planName}` : 'Switched to subscription';
    target.appendChild(note);
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    btn.classList.toggle('is-loading', !!on);
    if (on) {
      btn.dataset.originalText = btn.textContent;
      btn.textContent = 'Updating…';
    } else if (btn.dataset.originalText) {
      btn.textContent = btn.dataset.originalText;
      delete btn.dataset.originalText;
    }
  }

  // ========= CART OPS =========
  async function changeLineToSubscription(lineIndex, qty, planId) {
    // Prefer “change” with selling_plan – no re-add, keeps cart consistent
    return postJSON('/cart/change.js', {
      line: Number(lineIndex),
      quantity: Number(qty),
      selling_plan: Number(planId)
    });
  }

  async function removeLine(lineIndex) {
    return postJSON('/cart/change.js', { line: Number(lineIndex), quantity: 0 });
  }

  async function addSubscription(variantId, qty, planId) {
    return postJSON('/cart/add.js', {
      items: [{ id: Number(variantId), quantity: Number(qty), selling_plan: Number(planId) }]
    });
  }

  // ========= MAIN INJECTOR =========
  async function injectForRow(row) {
    if (row.dataset.rcDone === '1') return;

    // Find title link + line index input
    const link = row.querySelector('a.link.product-title, a.product-title, a[href*="/products/"]');
    const qtyInput = row.querySelector('.quantity__input[data-index]');
    if (!link || !qtyInput) { row.dataset.rcDone = '1'; return; }

    const { handle, variantId } = parseHandleAndVariantFromLink(link);
    const lineIndex = Number(qtyInput.getAttribute('data-index') || '0');
    const qty = Number(qtyInput.value || '1');

    if (!handle || !variantId || !lineIndex) { row.dataset.rcDone = '1'; return; }

    // If this line already has a subscription indicator in DOM (some themes show it), don’t add CTA
    if (row.querySelector('[data-selling-plan], .cart-item__selling-plan, .rc-upsell-switched')) { row.dataset.rcDone = '1'; return; }

    // Get first plan
    let plan;
    try {
      const productJson = await getJSON(`/products/${encodeURIComponent(handle)}.js`);
      plan = firstPlan(productJson);
    } catch { /* ignore */ }
    if (!plan) { row.dataset.rcDone = '1'; return; }

    // Inject CTA near the title
    const target = link.closest('.product-content') || row.querySelector('.product-description') || row;
    const cta = makeCTA(plan);
    target.appendChild(cta);
    row.dataset.rcDone = '1';

    const btn = cta.querySelector('.rc-upsell-link');

    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      forceDrawerOpen(); // keep it open right away
      setLoading(btn, true);

      // Remove CTA immediately after click so it won’t duplicate on re-inits
      // (if something fails)
      cta.remove();

      try {
        // 1) Try change-in-place with selling_plan (preferred)
        try {
          await changeLineToSubscription(lineIndex, qty, plan.id);
        } catch {
          // 2) Fallback: remove + add
          await removeLine(lineIndex);
          await addSubscription(variantId, qty, plan.id);
        }

        // Light DOM feedback: show “switched” note; do NOT rely on theme re-render
        showSwitchedBadge(target, plan.name);

        // Fire basic events listen to; do not replace HTML
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart:line:changed', { detail: { line: lineIndex } }));
        forceDrawerOpen();

      } catch (err) {
        console.error('[RC Upsell] switch failed', err);
        // Restore CTA so user can retry
        try { target.appendChild(cta); } catch {}
        forceDrawerOpen();
      } finally {
        setLoading(btn, false);
      }
    });
  }

function scanAndInject(root = document) {
  $$('.product-container', root).forEach(injectForRow);
  dedupeRechargeUpsell(root); // ensure no duplicate .rc-upsell-wrap elements
}

// ========= INIT + OBSERVERS =========
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', scanAndInject);
} else {
  scanAndInject();
}

const drawerRoot = document.querySelector(DRAWER_ROOT_SELECTOR) || document.body;
const mo = new MutationObserver(() => {
  // Re-run on drawer DOM changes (items added/removed/updated)
  scanAndInject(drawerRoot);
});
mo.observe(drawerRoot, { childList: true, subtree: true });

// keep our CTAs in sync and drawer open
document.addEventListener('cart:open', () => { 
  forceDrawerOpen(); 
  scanAndInject(drawerRoot); 
});
document.addEventListener('cart:updated', () => { 
  forceDrawerOpen(); 
  scanAndInject(drawerRoot); 
});

// ========= NEW: DUPE FIX =========
function dedupeRechargeUpsell(root = document) {
  $$('.product-description', root).forEach(desc => {
    const wraps = desc.querySelectorAll('.rc-upsell-wrap');
    if (wraps.length > 1) {
      wraps.forEach((wrap, i) => {
        if (i > 0) wrap.remove(); // remove duplicates, keep the first
      });
    }
  });
}

  // ========= inline styles =========
  const css = `
    .rc-upsell-link { background:transparent; border:0; padding:0; text-decoration:underline; cursor:pointer; font:inherit; }
    .rc-upsell-link.is-loading { opacity:.6; pointer-events:none; }
    .rc-upsell-hint { display:block; opacity:.75; }
    .rc-upsell-switched { margin-top:4px; }
  `;
  const style = document.createElement('style'); style.textContent = css; document.head.appendChild(style);
})();
